<!-- Brand Logo -->
<a [routerLink]="['/']" class="brand-link">
    <img src="/images/logos/BrandSimpleLaundry.png" alt="SimpleLaundry" class="brand-image" height="33"
        style="opacity: 0.9">
</a>
<!-- Sidebar -->
<div class="sidebar">
    <!-- Sidebar user (optional) -->
    <div class="user-panel mt-3 pb-3 mb-3 pr-1 d-flex justify-content-between">
        <div class="d-flex flex-row">
            <div class="image d-flex align-items-center">
                <pf-image [src]="user.img" fallback-src="assets/img/default-profile.png" class="img-circle"
                    alt="User Image" width="34" height="34" rounded></pf-image>
            </div>
            <div class="info-user d-flex align-items-center">
                <a class="d-block">
                    {{ user.nombre }}
                </a>
            </div>
        </div>
        <div class="d-flex align-items-center">
            <a class="link" (click)="logout()">
                <app-popover [classIcon]="'fas fa-power-off'" [colorIcon]="'text-danger'"
                    [message]="'Cerrar Sesión'"></app-popover>

            </a>
        </div>
    </div>

    <div class="form-inline">
        <app-sidebar-search></app-sidebar-search>
    </div>

    <nav class="mt-2" style="overflow: hidden" *ngIf="this.appService.user.role != 'delivery'">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            <li>
                <a class="btn btn-warning btn-block btn-lg text-dark" (click)="goToPedido()"><i
                        class="fas fa-shipping-fast"></i> Crear pedido</a>
            </li>
        </ul>
    </nav>

    <!-- Sidebar Menu -->
    <nav class="mt-2" style="overflow: hidden">
        <ul class="nav nav-pills nav-sidebar flex-column nav-child-indent" data-widget="treeview" role="menu"
            data-accordion="false">
            <app-menu-item *ngFor="let item of menu" [menuItem]="item"></app-menu-item>
        </ul>
    </nav>
</div>
<div class="sidebar-custom">
    <a [routerLink]="['/blank']" class="btn btn-link text-light" *ngIf="user.role == 'superadmin'"><i
            class="fas fa-cogs"></i></a>
    <a [routerLink]="['/perfil']" class="btn btn-link text-light" *ngIf="user.role != 'superadmin'"><i
            class="fas fa-user"></i></a>
    <!--    <a class="btn btn-link text-light"><i class="fas " [ngClass]="{'': darkMode, 'fa-moon':!darkMode}"></i></a> -->
    <!-- <a [routerLink]="['/blank']" class="btn btn-secondary hide-on-collapse pos-right">Ayuda</a> -->
    <app-popover [classIcon]="darkMode ? 'fas fa-sun' : 'fas fa-moon'" [colorIcon]="'text-light'"
        class="btn btn-link pos-right"
        [message]="darkMode ? '<em>Mostrar </em> <b>Modo Día</b>' : '<em>Mostrar </em> <b>Modo Nocturno</b>'"
        (click)="handleDarkModeChange()"></app-popover>
</div>